import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bell, Clock, Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';

export default function AdminReleases({ releases, isAdmin, newRelease, setNewRelease, handleCreateRelease }) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-testid="releases-tab">
      {isAdmin && (
        <Card className="border-0 shadow-lg">
          <CardHeader><CardTitle>Nouvelle Release</CardTitle></CardHeader>
          <CardContent>
            <form onSubmit={handleCreateRelease} className="space-y-4">
              <div><Label>Version</Label><Input value={newRelease.version} onChange={(e) => setNewRelease({...newRelease, version: e.target.value})} placeholder="v1.0.0" required /></div>
              <div><Label>Titre</Label><Input value={newRelease.title} onChange={(e) => setNewRelease({...newRelease, title: e.target.value})} placeholder="Nouvelle fonctionnalité..." required /></div>
              <div><Label>Description</Label><Textarea value={newRelease.description} onChange={(e) => setNewRelease({...newRelease, description: e.target.value})} placeholder="Détails des changements..." rows={4} required /></div>
              <Button type="submit" className="w-full bg-fuchsia-600 hover:bg-fuchsia-700"><Plus className="h-4 w-4 mr-2" />Créer la Release</Button>
            </form>
          </CardContent>
        </Card>
      )}
      <Card className={`border-0 shadow-lg ${isAdmin ? 'lg:col-span-2' : 'lg:col-span-3'}`}>
        <CardHeader><CardTitle>Historique des Releases</CardTitle></CardHeader>
        <CardContent>
          {releases.length === 0 ? (
            <p className="text-zinc-500 text-center py-8">Aucune release pour le moment</p>
          ) : (
            <div className="space-y-4">
              {releases.map((release, index) => (
                <div key={release.id} className={`p-4 rounded-lg ${index === 0 ? 'bg-lime-50 border-2 border-lime-200' : 'bg-zinc-50'}`}>
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-mono text-sm bg-zinc-200 px-2 py-1 rounded">{release.version}</span>
                    <span className="text-sm text-zinc-500"><Clock className="h-3 w-3 inline mr-1" />{new Date(release.release_date).toLocaleDateString('fr-FR')}</span>
                  </div>
                  <h4 className="font-semibold text-zinc-900">{release.title}</h4>
                  <p className="text-sm text-zinc-600 mt-1">{release.description}</p>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
